import { useEffect, useState } from 'react';
import axios from 'axios';
import { swalError, swalSuccess } from '../../../../../utils/swalAlert';

const serverUrl = `${process.env.REACT_APP_SERVER_URL}`;

const ManageModelConfig = () => {
  const [config, setConfig] = useState({
    customModelConfig: {},
    enableCustomModelConfig: false,
    models: {}
  });

  const [customConfig, setCustomConfig] = useState({
    model: '',
    temperature: 0.5,
    top_k: 50,
    top_p: 0.9,
    frequencyPenalty: 0.0,
    presencePenalty: 0.0,
    enableCustomModelConfig: false
  });

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await (await fetch(`${serverUrl}/api/config/get-model-config`)).json();
        if (!response) return;
        const { customModelConfig, enableCustomModelConfig, models } = response.data;
        setConfig({ customModelConfig, enableCustomModelConfig, models });
        setCustomConfig(customModelConfig);
      } catch (error) {
        swalError('Error fetching model config');
      }
    };

    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : parseFloat(value) || value;
    setCustomConfig({ ...customConfig, [name]: newValue });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${serverUrl}/api/config/update-model-config`, customConfig);
      swalSuccess('Model config updated successfully');
    } catch (error) {
      swalError('Error updating model config');
    }
  };

  return (
    <div className='config-container' style={{ width: '50%', margin: 'auto' }}>
      <h2>Model Configuration</h2>
      <form onSubmit={handleSubmit} className='config-form'>
        <div className="form-group">
          <label>Model</label>
          <select name="model" value={customConfig.model} onChange={handleChange} className="input-field">
            {Object.keys(config.models).map((modelKey) => (
              <option key={modelKey} value={modelKey}>
                {config.models[modelKey].name}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Temperature</label>
          <input type="number" name="temperature" value={customConfig.temperature} onChange={handleChange} className="input-field" />
        </div>

        <div className="form-group">
          <label>Top K</label>
          <input type="number" name="top_k" value={customConfig.top_k} onChange={handleChange} className="input-field" />
        </div>

        <div className="form-group">
          <label>Top P</label>
          <input type="number" name="top_p" value={customConfig.top_p} onChange={handleChange} className="input-field" />
        </div>

        <div className="form-group">
          <label>Frequency Penalty</label>
          <input type="number" name="frequencyPenalty" value={customConfig.frequencyPenalty} onChange={handleChange} className="input-field" />
        </div>

        <div className="form-group">
          <label>Presence Penalty</label>
          <input type="number" name="presencePenalty" value={customConfig.presencePenalty} onChange={handleChange} className="input-field" />
        </div>

        <div className="">
          <label>Enable Custom Config
            <input type="checkbox" name="enableCustomModelConfig" checked={customConfig.enableCustomModelConfig} onChange={handleChange} />
          </label>
        </div>

        <button type="submit" className='btn-submit'>Submit</button>
      </form>
    </div>
  );
};

export default ManageModelConfig;